
<template>
    <div class="model-content">
        <div class="mode24" :class="(posterList.lang == 'ug' || !posterList.lang) ? 'model_ug' : 'model_zh'">
            <div class="img-box">
                <img v-if="posterList.lang == 'ug' || !posterList.lang" style="width: 100%;" :src="moban_list.url_ug" />
                <img v-if="posterList.lang == 'zh'" style="width: 100%;" :src="moban_list.url_zh" />
            </div>

            <div class="merchant-name">
                <div class='merchant-name-title'>{{ posterList.merchant_name }}</div>
            </div>

            <div class="food_name">
                <div class="food_name_text">{{ posterList.food_name }}</div>
            </div>

            <div class="food_img">
                <img :src="posterList.food_img" alt="">
            </div>

            <div class="food_price" :style="{fontSize: posterList.fontSize + 'px'}">
                <span>{{ posterList.food_price }}</span>
            </div>

            <div class="old_price">
                <span style="text-decoration: line-through;">{{ posterList.old_price }}</span><span v-if="posterList.lang == 'zh'"> 元</span>
            </div>

            <div class="merchant_qrcode">
                <img :src="posterList.merchant_qrcode" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "model_24",
    data() {
        return {
            posterList: {},
            moban_list: {
                url_zh: require('../../img/poster/model_24_zh.jpg'),
                url_ug: require('../../img/poster/model_24_ug.jpg'),
            },
        };
    },
    created() {
        this.canvasfortitle(this.$route.query.merchant_name, this.$route.query.food_name, this.$route.query);
    },
    methods: {
        canvasfortitle(merchant_name, food_names, query) {
            let res_name = merchant_name.replaceAll('(', '-')
            res_name = res_name.replaceAll('（', '-')
            res_name = res_name.replaceAll(')', ' ')
            res_name = res_name.replaceAll('）', ' ')
            let food_name = food_names.replaceAll('(', '-')
            food_name = food_name.replaceAll('（', '-')
            food_name = food_name.replaceAll(')', ' ')
            food_name = food_name.replaceAll('）', ' ')
            this.posterList = query;
            this.posterList['merchant_name'] = res_name;
            this.posterList['food_name'] = food_name;
            const price = this.posterList.food_price.toString();
            let fontSize = 20;
            if(price.length <= 2) {
                fontSize = 45;
            } else if(price.length == 3) {
                fontSize = 40;
            } else if(price.length == 4) {
                fontSize = 35;
            } else if(price.length == 5) {
                fontSize = 27;
            } else if(price.length == 6) {
                fontSize = 22;
            }
            this.posterList.fontSize = fontSize;
        },
    },
};
</script>
  
<style scoped>
.model-content {
    width: 352px;
    height: 632px;
    position: relative;
    margin: auto;
    display: flex; 
    justify-content: center;
    
}

.mode24 {
    width: 352px;
    height: 632px;
    position: relative;
}

.model_ug {
    direction: rtl;
}

.model_zh {
    direction: ltr;
}

.img-box {
    width: 100%;
    height: 100%;
}

.merchant-name {
    position: absolute;
    top: 98px;
    right: 50%;
    transform: translateX(50%);
    color: #00ad00;
    width: 260px;
    height: 34px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.merchant-name-title {
    font-size: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.food_name {
    position: absolute;
    width: 260px;
    height: 34px;
    top: 194px;
    right: 50%;
    transform: translateX(50%);
    font-size: 20px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    text-align: center;
}

.food_name_text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.food_img {
    position: absolute;
    top: 258px;
    left: 69px;
    width: 221px;
    height: 199px;
    border-radius: 50%;
    overflow: hidden;
}

.food_img img {
    width: 100%;
    height: 100%;
}

.food_price {
    position: absolute;
    top: 450px;
    left: 32px;
    width: 76px;
    color: #fff;
    text-align: center;
    line-height: 38px;
    font-weight: bold;
}
.old_price {
    position: absolute;
    top: 470px;
    width: 46px;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    text-align: center;
}

.model_ug .old_price {
    right: 132px;
}

.model_zh .old_price {
    top: 466px;
    left: 188px;
    width: 70px;
}

.merchant_qrcode {
    position: absolute;
    top: 532px;
    left: 57px;
    width: 84px;
    height: 84px;
    background-color: #fff;
    border-radius: 50%;
    overflow: hidden;
    box-sizing: border-box;
}

.merchant_qrcode img {
    width: 100%;
    height: 100%;
}
</style>